import { AgencyCard, AgencyCardProps } from "./agencyCard/AgencyCard";
import styles from "./AgencyCardList.module.scss";

export type AgencyCardListProps = {
  title: string;
  agencyCards: AgencyCardProps[];
  openInNewTab?: boolean;
};

export const AgencyCardList = ({
  title,
  agencyCards,
  openInNewTab,
}: AgencyCardListProps) => {
  return (
    <div className={styles.agencyCardList}>
      <h2 className={styles.agencyCardListTitle}>{title}</h2>
      <div className={styles.agencyCards}>
        {agencyCards.map((agencyCard, index) => (
          <AgencyCard {...agencyCard} openInNewTab={openInNewTab} key={index} />
        ))}
      </div>
    </div>
  );
};
